$.each($('.multiupload'), function () {
    let $wrapper = $(this),
        $inputs = $wrapper.find('input[type="file"]'),
        orderCount = 0;

    // ensure at least one input is visible
    // and that inputs with errors are ordered first
    function ensureInput() {
        if (!$wrapper.find('.input--file.is-visible').length) {
            let $first = $wrapper.find('.input--file.has-error');

            if (!$first.length) {
                $first = $wrapper.find('.input--file');
            }

            $first.first()
                .addClass('is-visible')
                .css('order',  ++orderCount);
        }
    }

    ensureInput();

    // file multi upload
    $inputs.on('change', function () {
        let $input = $(this),
            $parent = $input.closest('.input--file'),
            $errors = $parent.find('.form-errors'),
            $inputsHidden = $wrapper.find('.input--file:not(.is-visible)');

        // remove errors
        $parent.removeClass('has-error');
        $errors.remove();

        if ($input.val()) {
            orderCount++;

            $parent.addClass('has-value');
            $inputsHidden.first()
                .addClass('is-visible')
                .css('order',  orderCount);
        } else {
            $parent.removeClass('has-value');
            $parent.removeClass('is-visible');
        }

        ensureInput();
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/multiupload.js